import { Component, Inject } from '@angular/core';
import { 
  MAT_DIALOG_DATA, 
  MatDialogModule, 
  MatDialogActions, 
  MatDialogContent 
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-info-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogContent
],
  standalone: true,
  templateUrl: './info-dialog.html',
  styleUrl: './info-dialog.scss'
})
export class InfoDialog {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

}
